import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { SelectableChip } from '@aimsos/ui';

import { ACTIVITY_QUICK_FILTERS } from '../../constants/profileTabs.js';

/**
 * The quick-filter chips of the Activity tab: All, Communications, Notes.
 *
 * Pill chips, as in the prototype — not a `SegmentedControl`. Events and Tasks
 * are drawn by the prototype but are not v2.0, so they are not in the list.
 * Each chip is a toggle button (`aria-pressed`), and exactly one is on: picking
 * the active one again changes nothing.
 */
const ActivityQuickFilters = memo(function ActivityQuickFilters({ value, onChange, disabled = false }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <div
      role="group"
      aria-label={t('activity.quickFilters.ariaLabel')}
      data-testid="activity-quick-filters"
      className="flex flex-wrap items-center gap-2"
    >
      {ACTIVITY_QUICK_FILTERS.map((id) => (
        <SelectableChip
          key={id}
          size="m"
          selected={value === id}
          disabled={disabled}
          // One handler per chip: the id is the payload, so no event round-trip.
          onClick={() => onChange(id)}
        >
          {t(`activity.quickFilters.${id}`)}
        </SelectableChip>
      ))}
    </div>
  );
});

export default ActivityQuickFilters;
